import { render } from "./AppsView.vue?vue&type=template&id=f738848e"
import script from "./AppsView.vue?vue&type=script&lang=js"
export * from "./AppsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__